<template>
  <div id="wuPage">
    <div class="classBox" style="overflow: hidden;">
        <div class="box_list" v-show="classList.length > 0" v-for="(item, index) in classList" :key="index"
          @click="toDetail(item.id)">
          <img :src="item.departCover_url" alt="" />
          <p class="box_text box_text1" style="">{{ item.departName }}</p>
        </div>
        <p v-if="classList.length == 0" class="listTips">暂无数据</p>
      </div>
  </div>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
  name: '',
  components: {},
  data() {
    return {
        classList:[]
    }
  },
  created() {this.init()},
  mounted() {},
  methods: {
    init(){
        getAction('sys/sysDepart/mineClassroom').then(res=>{
            console.log(res , '我的班级')
            if(res.success){
                this.classList = res.result
            }
        })
    },
    toDetail(id){
        this.$router.push({
        path: 'classDetails',
        query: {
          id: id,
        },
      })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
